import { useEffect, useState, useRef } from "react";
import Header from "../Components/Header/Header";
import HeaderWhite from "../Components/Header/HeaderWhite";
import Footer from "../Components/Footer/Footer";
import { businessPages } from "../actions/ApiCalls";
import './app.css';
import {IMAGE_URL} from "../path";

function Partnership() {
    const [data, setData] = useState<any[]>([]);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const publicUrl = IMAGE_URL;
    const firstTextRef = useRef<HTMLDivElement | null>(null);
    const navigationRef = useRef<HTMLDivElement | null>(null);
    const [currentHash, setCurrentHash] = useState('#partnership');
    const [isAtTop, setIsAtTop] = useState(true);

    const linkStyle: React.CSSProperties = {
        color: 'white',
        fontSize: '10px',
        fontFamily: "'Vinimark-Diatype', sans-serif",
        fontWeight: 600,
        textTransform: 'uppercase',
        textDecoration: 'underline',
        textUnderlineOffset: '2px',
        cursor: 'pointer',
        lineHeight: '13px'
    };

    let foundFirstTextSection = false;
    let foundFirstImageSection = false;
    let navigationInserted = false;

    useEffect(() => {
        const handleScroll = () => setIsAtTop(window.scrollY === 0);
        window.addEventListener("scroll", handleScroll);
        handleScroll();
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const id = entry.target.getAttribute("id");
                        if (id) {
                            setCurrentHash(`#${id}`);
                        }
                    }
                });
            },
            { root: null, rootMargin: '0px', threshold: 0.6 }
        );

        const sections = document.querySelectorAll(".our-story-text-section-wrapper[id]");
        sections.forEach((section) => observer.observe(section));

        return () => {
            sections.forEach((section) => observer.unobserve(section));
        };
    }, [data]);

    useEffect(() => {
        document.title = "Vinimark | Partnership";

        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        businessPages(3)
            .then(response => {
                setData(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch business pages:", error);
            });

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const renderNavigationList = () => (
        <ul className="navigation-list">
            {data
                .filter(page => page.right_text && page.title)
                .map((page, index) => {
                    const id = page.title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '');
                    const isActive = `#${id}` === currentHash;

                    return (
                        <li key={index}>
                            <a
                                href={`#${id}`}
                                className={isActive ? 'active' : ''}
                                onClick={(e) => {
                                    e.preventDefault();
                                    const el = document.getElementById(id);
                                    if (el) {
                                        const yOffset = -100;
                                        const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                                        window.scrollTo({ top: y, behavior: 'smooth' });
                                    }
                                    setCurrentHash(`#${id}`);
                                }}
                            >
                                {page.title}
                            </a>
                        </li>
                    );
                })}
        </ul>
    );

    const scrollToTarget = () => {
        let targetElement = isMobile ? navigationRef.current : firstTextRef.current;
        if (targetElement) {
            const yOffset = -100; // offset 50px above for both mobile and desktop
            const y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            position: 'relative'
        }}>
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
                {isAtTop ? <HeaderWhite /> : <Header />}
            </div>

            <div style={{ flex: '1', paddingTop: 0 }}>
                <div className="our-story-container">
                    {data.map((page, index) => {
                        const imageUrl = `${publicUrl}/${isMobile ? page.mobile_image : page.image}`;
                        const isTextSection = !page.image;
                        const assignRef = isTextSection && !foundFirstTextSection;
                        if (assignRef) foundFirstTextSection = true;

                        const isFirstImageWithTitle = page.image && page.title && !foundFirstImageSection;
                        if (isFirstImageWithTitle) foundFirstImageSection = true;

                        const isMobimarketSection = page.title === 'INTEGRATED TECHNOLOGY SOLUTIONS';
                        const isEducationSection = page.title === 'EDUCATION';

                        return (
                            <div key={index}>
                                {page.image ? (
                                    page.title ? (
                                        <>
                                            {isFirstImageWithTitle && (
                                                <div
                                                    style={{
                                                        backgroundImage: `url(${imageUrl})`,
                                                        width: '100vw',
                                                        height: window.innerWidth > 835 ? '100vh' : '90vh',
                                                        backgroundSize: 'cover',
                                                        backgroundPosition: 'center',
                                                        display: 'flex',
                                                        alignItems: 'flex-start',
                                                        marginBottom: '80px'
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            position: window.innerWidth > 768 ? 'relative' : 'static',
                                                            left: window.innerWidth > 768 ? '50%' : 'auto',
                                                            marginTop: '140px',
                                                            width: window.innerWidth > 768 ? '50%' : '80%',
                                                            textAlign: 'left',
                                                            color: 'white',
                                                            fontFamily: "'Vinimark-Diatype', sans-serif",
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            height: window.innerWidth > 835 ? '90%' : '70%',
                                                            justifyContent: 'flex-end',
                                                            marginBottom: '80px'
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize: '32px',
                                                                fontWeight: 200,
                                                                textTransform: "uppercase",
                                                                marginBottom: '10px',
                                                                paddingLeft: window.innerWidth > 835 ? '0' : '20px',
                                                                marginLeft: window.innerWidth > 835 ? '26px' : 0,
                                                                lineHeight: '32px',

                                                            }}
                                                        >
                                                            {page.title}
                                                        </div>
                                                        <a
                                                            onClick={scrollToTarget}
                                                            style={{
                                                                color: 'white',
                                                                fontSize: '10px',
                                                                lineHeight: '16.9px',
                                                                marginBottom: window.innerWidth > 835 ? '112px' : '30px',
                                                                cursor: 'pointer',
                                                                textDecoration: 'underline',
                                                                textUnderlineOffset: '2px',
                                                                display: 'inline-block',
                                                                textTransform: 'uppercase',
                                                                fontWeight: 600,
                                                                marginLeft: '26px',
                                                            }}
                                                        >
                                                            Read more
                                                        </a>
                                                    </div>
                                                </div>
                                            )}

                                            {!isFirstImageWithTitle && (
                                                <img
                                                    src={imageUrl}
                                                    alt="Business Page"
                                                    className={page.is_full ? "our-story-image-full" : "our-story-image-centered"}
                                                />
                                            )}

                                            {isMobile && isFirstImageWithTitle && !navigationInserted && (
                                                <div
                                                    style={{ padding: '24px 24px 48px 24px' }}
                                                    ref={navigationRef}
                                                >
                                                    {renderNavigationList()}
                                                    {navigationInserted = true}
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <img
                                            src={imageUrl}
                                            alt="Business Page"
                                            className={page.is_full ? "our-story-image-full" : "our-story-image-centered"}
                                        />
                                    )
                                ) : (
                                    <div
                                        className="our-story-text-section-wrapper"
                                        ref={assignRef ? firstTextRef : null}
                                        id={page.title ? page.title.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '') : undefined}
                                    >
                                        <div className={`our-story-text-section ${isMobile ? "mobile" : ""}`}>
                                            <div className="navigation-container">
                                                {!isMobile && renderNavigationList()}
                                            </div>
                                            <div className="our-story-text-block" style={{ marginLeft: isMobile ? '5px' : '90px' }}>
                                                <div style={{ width: isMobile ? '100%' : '70%' }}>
                                                    <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: ((): any => {
                                                                const rightText = page.right_text || '';
                                                                const styledRightText = rightText.replace(/<p>/g, '<p style="font-weight: 400">');
                                                                return `${page.title ? `<h2 style="font-weight: 600" class="our-story-title">${page.title}</h2>` : ''}${styledRightText}`;
                                                            })()
                                                        }}
                                                    />
                                                    {isMobimarketSection && (
                                                        <div style={{ marginTop: '20px' }}>
                                                            <a
                                                                href="https://vinimark.mobi/logon.aspx?ReturnUrl=%2f"
                                                                style={{ ...linkStyle, color: '#000' }}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Mobimarket
                                                            </a>
                                                        </div>
                                                    )}
                                                    {isEducationSection && (
                                                        <div style={{ display: 'flex', gap: '10px', marginTop: '-30px' }}>
                                                            <a
                                                                href="/webinars"
                                                                style={{ ...linkStyle, color: '#000' }}
                                                            >
                                                                VIEW WEBINARS
                                                            </a>
                                                            <a
                                                                href="/podcasts"
                                                                style={{ ...linkStyle, color: '#000' }}
                                                            >
                                                                LISTEN TO PODCASTS
                                                            </a>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Partnership;
